import { fadeIn, fadeOut } from "../../utilities/helpers";
import { getPrice } from '../product/price';

export function addToCart(selector: HTMLElement, articleId: string, articleTitle: string, articleImage?: string, basketQuantity?: string) {
    async function postData(url = '', data: string) {
        const response = await fetch(url, {
            method: 'POST',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: data
        });
        return response;
    }
    basketQuantity = basketQuantity || '1';
    const articleSettings = 'quantity=' + basketQuantity + '&articleId=' + articleId;

    postData('/order/cart/item', articleSettings)
        .then(data => {
            const modal = document.getElementById('modal-addedtobasket');
            if( data.ok && modal ) {

                modal.querySelector('.modal-product-image').innerHTML = '<img src="'+ articleImage +'" alt="">';
                modal.querySelector('.modal-product-title').innerHTML = articleTitle;
                getPrice(articleId, parseInt(basketQuantity), 'summary').then((articleSumAllPricesSnippet: any) => {
                  document.querySelector('.modal-product-sum-all-prices').innerHTML = articleSumAllPricesSnippet;
                });
                modal.querySelector('.modal-product-id').innerHTML = articleId;

                fadeIn(modal);
                fadeIn(document.querySelector('.modal-background'));
            }
        });
}
